const STORAGE_KEY = "wayli_session_id";

const fallbackId = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;

export const getOrCreateSessionId = () => {
  try {
    if (typeof window === "undefined") return fallbackId();
    const existing = window.localStorage?.getItem?.(STORAGE_KEY);
    if (existing) return existing;
    const next =
      typeof window.crypto?.randomUUID === "function"
        ? window.crypto.randomUUID()
        : fallbackId();
    window.localStorage?.setItem?.(STORAGE_KEY, next);
    return next;
  } catch {
    return fallbackId();
  }
};

export const clearSessionId = () => {
  try {
    if (typeof window === "undefined") return;
    window.localStorage?.removeItem?.(STORAGE_KEY);
  } catch {
    // Ignore storage failures.
  }
};

const sessionIdUtils = { getOrCreateSessionId, clearSessionId };

export default sessionIdUtils;
